import Api from './api'

// Admin_User_Api client service. Wraps the JWT-attaching Api_Client (see ./api)
// so every request carries the session bearer token, and maps onto the server
// routes mounted under /api/administration/users.
//
// Those routes sit behind BOTH the isAuthenticated middleware (like the rest of
// /administration) and the isAdmin policy, so a signed-in employee calling any
// of these gets a 403. The client-side route guard keeps non-admins off the
// screens that use this service, so a 403 here means either a role that was
// revoked mid-session or a direct call outside the UI.
//
// Role values are the strings the server expects: 'admin' or 'employee'.
export default {
  // List every account for the User_List.
  list () {
    return Api().get('administration/users')
  },

  // Fetch a single account by id to populate the User_Editor.
  get (id) {
    return Api().get(`administration/users/${id}`)
  },

  // Create an account. `user` carries { email, password, role, first_name,
  // last_name, company, company_title }.
  create (user) {
    return Api().post('administration/users', user)
  },

  // Update an account's supplied fields. Omitted fields are left as stored; in
  // particular, omit `password` entirely to leave the existing credential
  // untouched rather than sending an empty string.
  update (id, user) {
    return Api().put(`administration/users/${id}`, user)
  },

  // Change only an account's role. Used by the inline toggle in the User_List so
  // it does not have to round-trip the rest of the user's fields.
  setRole (id, role) {
    return Api().patch(`administration/users/${id}/role`, { role })
  },

  // Delete an account.
  remove (id) {
    return Api().delete(`administration/users/${id}`)
  }
}
